<template>
  <div class="ebook-page">
    <div class="ebook-page-navigate position-relative">
      <video src="../../assets/source/bg-video.mp4" muted loop autoplay />
      <div class="ebook-page-navigate-body position-relative">
        <div class="ebook-page-navigate-body-content safe-with flex-row-center-between">
          <p class="font-bold font-36 font-color-fff tit">书目推荐</p>
          <div class="search flex-row-center">
            <el-input v-model="searchKey" placeholder="关键字检索" size="normal" clearable @change="inputChange" />
            <img class="flex-shrink" src="../../assets/img/icon-source-search.png" @click="toSearch">
          </div>
        </div>
      </div>
    </div>
    <div v-if="cateAry.length" class="ebook-page-list">
      <div class="ebook-page-list-body safe-with flex">
        <div class="ebook-page-list-body-left flex-shrink">
          <div class="ebook-page-list-body-left-body">
            <div v-for="(item, index) in cateAry" :key="index" class="ebook-page-list-body-left-body-item flex-row-center cursor" :class="cateId==item.code?'sel':''" @click="newCateTap(item)">
              <p class="font-14">{{ item.name }}</p>
            </div>
          </div>
        </div>
        <div class="ebook-page-list-body-right flex-1">
          <div class="ebook-page-list-body-right-tit flex-row-center-between">
            <p v-if="!showKey" class="font-bold font-16">{{ cateId == 0 ? '' : getCateName(cateId) }}</p>
            <p v-else class="font-bold font-16">“{{ showKey }}”的搜索结果</p>
            <p v-if="!sourceInfo" class="font-12">{{ list.length }}条</p>
            <p v-else class="font-12 cursor" @click="returnList">返回列表</p>
          </div>
          <div v-if="sourceInfo">
            <source-info ref="bk" />
          </div>
          <div v-else>
            <div v-if="list.length">
              <div class="ebook-page-list-body-right-list flex">
                <div v-for="(item, index) in list" :key="index" class="ebook-page-list-body-right-list-item cursor" @click="toDetail(item)">
                  <div v-if="item.coverImg" class="img flex-center" :style="{backgroundImage: 'url(' + item.coverImg + ')'}">
                    <img class="cursor" src="../../assets/img/icon-history-check.png">
                  </div>
                  <div v-else class="img default-img-cover" />
                  <p class="tit font-14 text-line-1">{{ item.bookName }}</p>
                </div>
              </div>
              <div class="ebook-page-list-body-right-list-page flex-center">
                <el-pagination
                  background
                  :page-size="20"
                  layout=" prev, pager, next"
                  :total="pages"
                  @current-change="pageChage"
                />
              </div>
            </div>
            <div v-else class="ebook-page-list-body-right-error flex-column-center">
              <img src="../../assets/img/icon-list-error.png">
              <p class="font-14 font-color-999">暂无数据</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/index.js'
import sourceInfo from './components/info/index.vue'
import { getShowPath } from '@/utils/imgpath.js'
export default {
  components: {
    sourceInfo
  },
  data() {
    return {
      list: [],
      currPage: 1,
      pages: 0,
      cateIndex: 0,
      cateAry: [],
      searchKey: '',
      showKey: '',
      sourceInfo: null,

      cateId: 0,
      sourceId: 0,
      fromList: 0
    }
  },
  watch: {
    $route(to, from) {
      const id = this.$route.query.sourceId ?? 0
      this.fromList = this.$route.query.list ?? 0
      this.searchKey = this.$route.query.key ?? ''
      this.showKey = this.$route.query.key ?? ''
      if (this.sourceId !== id) {
        this.sourceId = id
      }
      if (id === 0) {
        this.sourceInfo = null
      }
      this.cateId = this.$route.query.cateId ?? 0
      this.request()
    }
  },
  created() {
    this.cateId = this.$route.query.cateId ?? 0
    this.sourceId = this.$route.query.sourceId ?? 0
    this.fromList = this.$route.query.list ?? 0
    this.searchKey = this.$route.query.key ?? ''
    this.showKey = this.$route.query.key ?? ''
    this.requestCatalog()
  },
  methods: {
    getCateName(val) {
      const value = this.cateAry.filter(v => v.code === val)
      if (value.length) {
        return value[0].name
      }
    },
    async requestCatalog() {
      const res = await api.getListByParentId({ parentId: 965 })
      if (res.code === 2000) {
        this.cateAry = res.items
        if (this.cateId === 0 && this.searchKey === '') {
          this.cateId = this.cateAry[0].code
        }
      }
      this.request()
    },
    request() {
      api.getBookList({
        keyWords: this.searchKey,
        catalogId: this.cateId,
        page: this.currPage,
        limit: 20
      }).then(res => {
        if (res.code === 2000) {
          res.items.data.forEach(value => {
            value.coverImg = getShowPath('img', value.coverImg)
          })
          this.list = res.items.data
          this.pages = res.items.totalCount

          if (this.sourceId !== 0) {
            const index = this.list.findIndex(v => String(v.id) === this.sourceId)
            if (index >= 0) {
              this.checkDetail(index)
            }
          }
        }
      })
    },
    pageChage(v) {
      this.currPage = v
      this.request()
    },
    newCateTap(val) {
      if (val.code === this.cateId) {
        return
      }
      this.sourceInfo = null
      this.searchKey = ''
      this.cateId = val.code
      this.$router.push({
        path: '/book',
        query: {
          cateId: val.code
        }
      })
    },
    toDetail(val) {
      this.$router.push({
        path: '/book',
        query: {
          cateId: val.catalogId,
          sourceId: val.id,
          list: 1
        }
      })
    },
    checkDetail(val) {
      this.sourceInfo = this.list[val]
      setTimeout(() => {
        this.$refs.bk.showInfo(this.sourceInfo, val, this.list)
      }, 100)
    },
    returnList() {
      this.sourceInfo = null
      if (this.fromList) {
        this.$router.back()
      } else {
        this.$router.push({
          path: '/book',
          query: {
            cateId: this.cateId
          }
        })
      }
    },
    inputChange() {
      this.showKey = this.searchKey
      this.toSearch()
    },
    toSearch() {
      this.sourceId = 0
      this.sourceInfo = null
      this.cateId = 0
      if (this.searchKey) {
        this.$router.push({
          path: '/book',
          query: {
            key: this.searchKey
          }
        })
      } else {
        this.$router.push({
          path: '/book',
          query: {
            cateId: this.cateAry[0].code
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
 /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
   background-color: #B21F12;
 }

 /deep/.el-pagination.is-background .btn-prev {
   min-width: 40px;
   border-radius: 5px;
 }

 /deep/.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev {
   min-width: 40px;
   border-radius: 5px;
 }
 /deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
   color: #B21F12;
 }
 /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
   color: #fff;
 }

 /deep/.el-pagination.is-background .el-pager li.active {
   border: none;
 }

 /deep/.el-pagination.is-background .el-pager li {
   min-width: 40px !important;
   background-color: #fff;
   border: 1px solid #F7F7F7;
 }
</style>

<style scoped>
  .ebook-page-navigate {
    background-image: url('../../assets/img/bg-notice-navigate.png');
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    height: 200px;
    margin-top: -60px;
  }

  .ebook-page-navigate video {
    width: 100%;
    height: 100%;
    object-fit: fill;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
  }

  .ebook-page-navigate-body {
    height: 200px;
    z-index: 1;
  }

  .ebook-page-navigate-body-content {
    padding-top: 120px;
  }

  .ebook-page-navigate-body-content .tit {
    line-height: 80px;
  }

  .ebook-page-navigate-body-content .search {
    width: 300px;
    height: 40px;
    background: rgba(0, 0, 0, 0.15);
    border-radius: 5px;
    padding: 0 10px;
  }

  .ebook-page-navigate-body-content .search img {
    margin-left: 10px;
  }

  .ebook-page-navigate-body-content .search input {
    outline: none;
    height: 100%;
    border: none;
    background-color: rgba(0, 0, 0, 0);
    color: #fff;
  }

  .ebook-page-navigate-body-content .search input::placeholder {
    color: rgba(255, 255, 255, 0.6);
  }

  .ebook-page-list-body-right {
    margin-left: 30px;
  }

  .ebook-page-list-body-right-tit {
    margin-top: 10px;
    height: 50px;
    border-width: 0px 0px 1px 0px;
    border-style: solid;
    border-color: #EEEEEE;
  }

  .ebook-page-list-body-right-tit p:last-child {
    color: #767676;
  }

  .ebook-page-list-body-left {
    width: 220px;
  }

  .ebook-page-list-body-right-list {
    padding-top: 30px;
    flex-wrap: wrap;
  }

  .ebook-page-list-body-right-list-item {
    width: 176px;
    margin-bottom: 30px;
    margin-right: 20px;
  }

  .ebook-page-list-body-right-list-item:nth-child(5n) {
    margin-right: 0;
  }

  .ebook-page-list-body-right-list-item .img {
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    width: 176px;
    height: 250px;
    border-radius: 3px;
  }

  .ebook-page-list-body-right-list-item .tit {
    line-height: 20px;
    color: #3D3D3D;
    margin-top: 10px;
  }

  .ebook-page-list-body-right-list-item .img img {
    opacity: 0;
  }

  .ebook-page-list-body-right-list-page {
    margin: 60px 0;
  }

  .ebook-page-list-body-left-body {
    width: 100%;
    height: 400px;
    padding-top: 10px;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.03) 100%);
  }

  .ebook-page-list-body-left-body-item {
    height: 50px;
    border-image: linear-gradient(90deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0) 100%) 0 0 1 0;
    border-width: 0px 0px 1px 0px;
    border-style: solid;
    padding: 0 20px;
  }

  .ebook-page-list-body-left-body-item.sel p{
    font-weight: bold;
  }

  .ebook-page-list-body-right-error {
    height: 500px;
    justify-content: center;
  }

  .ebook-page-list-body-right-error img {
    margin-bottom: 10px;
  }

</style>

<style lang="scss" scoped>
  /deep/.el-input__inner {
    color: #fff;
    font-size: 14px;
    border: none;
    height: 38px;
    background-color: rgba($color: #fff, $alpha: 0);
  }

</style>
